module.exports = __webpack_public_path__ + "img/zaixianzhifu_icon_xzczfs.eb0f11d3.png";